import { actions, getters, mutations, state } from '@topgeschenken/front-library/store/account';

export default {
  state,
  actions,
  mutations,
  getters,
};
